import React, {Component} from 'react'
import '../styles/Admin.css'
import SidebarAdmin from "../shared/SidebarAdmin";
import HeaderAdmin from "../shared/HeaderAdmin";

export default class AdminPanel extends Component {

    constructor(props) {
        super(props);

        let linkActive = 0;

        if (this.props.link !== undefined && this.props.link !== null) {
            linkActive = this.props.link;
        }

        console.log(this.props.link);

        this.state = {
            linkActive: linkActive
        }
    }

    render() {
        return <div style={{background: '#eaeaea'}}>
            <HeaderAdmin/>
            <SidebarAdmin/>
            <div className="adminPanelContainer" style={{fontSize: '0.875rem'}}>
                {this.props.children}
            </div>
        </div>
    }
}



// WEBPACK FOOTER //
// ./src/components/admin/AdminPanel.js